import { render, staticRenderFns } from "./GroupManagement.vue?vue&type=template&id=4c0f6862&scoped=true"
import script from "./GroupManagement.vue?vue&type=script&lang=js"
export * from "./GroupManagement.vue?vue&type=script&lang=js"
import style0 from "./GroupManagement.vue?vue&type=style&index=0&id=4c0f6862&prod&lang=css"
import style1 from "./GroupManagement.vue?vue&type=style&index=1&id=4c0f6862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0f6862",
  null
  
)

export default component.exports